import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '../../../../shared/patterns/material-module';
import { IOutreachEmailRes } from '../../models/outreach-email.models';
import {
  IExpertEmailData,
  OutreachEmailComponent,
} from '../outreach-email/outreach-email.component';

@Component({
  selector: 'app-outreach-email-dialog',
  templateUrl: './outreach-email-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MaterialModule, OutreachEmailComponent],
})
export class OutreachEmailDialogComponent {
  private readonly dialogRef = inject(
    MatDialogRef<OutreachEmailDialogComponent>
  );
  readonly emailData = inject<IExpertEmailData>(MAT_DIALOG_DATA);

  onEmailSent(res: IOutreachEmailRes) {
    this.dialogRef.close(res);
  }

  close() {
    this.dialogRef.close();
  }
}
